import { useMemo } from "react";

import { ItemType, UserEvent } from "@/api";
import { Header } from "@/app/modules/Navigation";
import { PageLoader } from "@/components";
import { ITEM_TYPE_VIDEO } from "@/const.ts";
import { useRecentlyWatched, useVideos } from "@/hooks";
import { Clock } from "@/icons/index.tsx";

import { PlaylistGrid } from "./components/PlaylistGrid.tsx";
import { useTranslate } from "@/providers/context";

export const RecentlyWatched = () => {
  const { data, videoIds } = useRecentlyWatched();
  const { translate } = useTranslate();
  const noVideos = data && data.length === 0;

  const items = useMemo(() => {
    const items: { ChildId: string; Type: ItemType }[] = [];
    const watchedEvents: UserEvent[] = data ?? [];
    for (const event of watchedEvents) {
      if ([ITEM_TYPE_VIDEO].includes(event.ItemType)) {
        items.push({ ChildId: event.ItemId, Type: event.ItemType });
      }
    }
    return items;
  }, [data]);
  const { videoById } = useVideos({ ids: videoIds });

  // Wait for the Recently Watched -> Videos to load in
  const contentNotLoaded = !videoById;
  if (contentNotLoaded && !noVideos) {
    return <PageLoader />;
  }

  return (
    <div className="h-full px-7">
      <Header
        content={<div className="p1-bold">{translate("Recently Watched")}</div>}
      />
      {contentNotLoaded || noVideos ? (
        <div className="flex h-4/5 w-full  items-center justify-center">
          <div className="flex w-[240px] flex-col items-center text-center">
            <Clock className="text-item-primary h-[68px] w-[68px]" />
            <div className="h4-bold mt-4 capitalize">
              {translate("No recently watched")}
            </div>
            <div className="p1 text-item-secondary mt-2">
              {translate("Looks like you haven’t watched any videos yet")}
            </div>
          </div>
        </div>
      ) : (
        <div>
          <PlaylistGrid
            fullItems={{ videos: videoById, collections: {} }}
            items={items}
          />
          <div className="p2-medium text-item-secondary pb-8 pt-10 text-center">
            {translate("Videos shown are from the last 30 days")}
          </div>
        </div>
      )}
    </div>
  );
};
